import React, { useRef } from "react";
import { Modal, Button } from "react-bootstrap";
import { Icon } from "@iconify/react";
import Barcode from "react-barcode";

const BarcodeGenerator = ({ show, onHide, selectedItems }) => {
  const printRef = useRef();

  const handlePrint = () => {
    const printContent = printRef.current;
    const printWindow = window.open("", "_blank");

    printWindow.document.write(`
      <html>
        <head>
          <title>Jewellery Barcodes</title>
          <style>
            @page {
              size: A4;
              margin: 10mm;
            }
            body { 
              margin: 0;
              padding: 20px;
              font-family: Arial, sans-serif;
            }
            .barcode-grid {
              padding: 10px;
            }
            .barcode-item {
              background: white;
              padding: 10px;
              border: 1px solid #e0e0e0;
              border-radius: 4px;
              box-shadow: 0 1px 3px rgba(0,0,0,0.1);
              text-align: center;
            }
            .barcode-item p {
              margin: 4px 0;
              font-size: 11px;
              color: #333;
            }
            .barcode-item .tag-no {
              font-weight: bold;
              color: #000;
            }
            @media print {
              body {
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
              }
              .barcode-grid {
                page-break-inside: avoid;
              }
              .barcode-item {
                break-inside: avoid;
              }
            }
          </style>
        </head>
        <body>
          ${printContent.innerHTML}
          <script>
            window.onload = function() {
              window.print();
              window.onafterprint = function() {
                window.close();
              };
            };
          </script>
        </body>
      </html>
    `);
    printWindow.document.close();
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <Icon icon="solar:barcode-bold" className="me-2" />
          Barcode
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div ref={printRef}>
          <div className="row barcode-grid g-3">
            {selectedItems.map((item) => (
              <div key={item.id} className="col-12 col-sm-6 col-md-4">
                <div className="barcode-item">
                  <Barcode
                    value={item.tagNo || item.id}
                    width={1.5}
                    height={55}
                    fontSize={12}
                    margin={5}
                  />
                  {/* <p className="tag-no">Tag No: {item.tagNo}</p>
                  <p>Design: {item.design}</p>
                  <p>Size: {item.size}</p> */}
                </div>
              </div>
            ))}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handlePrint}>
          <Icon icon="solar:printer-bold" className="me-2" />
          Print
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default BarcodeGenerator;
